import type { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { type UpdateStrategyValues, updateStrategySchema } from './UpdateStrategyForm.schema'

type Submit = ReturnType<UseFormReturn<UpdateStrategyValues>['handleSubmit']>
type Props = Omit<UseFormProps<UpdateStrategyValues>, 'resolver'> & {
  strategyTypes: string[]
  onSubmit: SubmitHandler<UpdateStrategyValues>
  children: (form: UseFormReturn<UpdateStrategyValues>, submit: Submit) => React.ReactNode
}

export const UpdateStrategyForm = ({ strategyTypes, onSubmit, children, ...options }: Props) => {
  const form = useFormWithSchema({ mode: 'all', ...options }, updateStrategySchema(strategyTypes))
  const submit = form.handleSubmit(onSubmit)

  return (
    <Form {...form}>
      <form onSubmit={submit}>{children(form, submit)}</form>
    </Form>
  )
}
